import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from "./header.module.scss";
import UserProfile from "../../../static/images/picture-icon-default.png";
import { Link, useLocation } from "react-router-dom";
import { Notification } from "./notification";
import { getFacilityLabel } from "../../../utils";
import { PatientSearch } from "./patientSearch";
import { Breadcrumb } from "./breadcrumb";
import CustomerDetails from "./CustomerDetails";
import { openMenu } from "../../../app/menuSlice";
import { LogoMenuBlock } from "./LogoMenuBlock";

export const HeaderContainer = ({ heading, subHeading, workListView = false, formulary, reportHeading, patientView, breadcrumbs, type }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  /* State to check drop down assw */
  const [viewDrop, setDrop] = useState(false);
  const dropRef = useRef(null);
  const headerRef = useRef(null);

  useEffect(() => {
    const updatePadding = () => {
      const isDesktop = window.innerWidth >= 992; // matches lg breakpoint
      if (isDesktop) {
        // Desktop header is position:relative — no offset needed
        document.body.style.paddingTop = "0px";
        return;
      }
      if (headerRef.current) {
        const height = headerRef.current.getBoundingClientRect().height;
        document.body.style.paddingTop = `${height}px`;
      }
    };

    updatePadding(); // run on mount
    window.addEventListener("resize", updatePadding);
    return () => {
      window.removeEventListener("resize", updatePadding);
      document.body.style.paddingTop = "0px"; // clean up on unmount
    };
  }, []);

  useEffect(() => {
    if (window.innerWidth < 992 && headerRef.current) {
      const height = headerRef.current.getBoundingClientRect().height;
      document.body.style.paddingTop = `${height}px`;
    }
  }, [heading, subHeading, breadcrumbs]);

  useEffect(() => {
    setDrop(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropRef.current && !dropRef.current.contains(e.target)) {
        setDrop(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Display user details in worklist page
  const userDetails = useSelector((state) => state.user);
  const getFacilities = useSelector((state) => state.patient.newFacilitiesData);
  const otherPageFacilityCheck = useSelector((state) => state.patient.otherPageFacilityCheck);
  const chechFaciData =
    otherPageFacilityCheck &&
    getFacilities &&
    getFacilities.data &&
    Array.isArray(getFacilities.data.facilities) &&
    getFacilities.data.facilities.filter((f) => f.facilityNumber === otherPageFacilityCheck);
  const facilityData = chechFaciData && chechFaciData[0] ? chechFaciData[0] : null;
  const Details = useSelector((state) => state.user.userDetails);

  const homeOrigin = window.location.origin;

  const handleOpenMenu = (e) => {
    e.stopPropagation();
    dispatch(openMenu());
  };

  return (
    <div className={style.header}>
      <nav className={`navbar navbar-expand-lg navbar-dark ${style.custom_nav}`}>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarColor01"
          aria-controls="navbarColor01"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="w-auto col-lg-8 p-0">
          <LogoMenuBlock homeOrigin={homeOrigin} onOpen={handleOpenMenu} />
          {!workListView && (
            <>
              <Breadcrumb breadcrumbs={breadcrumbs} />
              {type === "CUSTOMER_DETAILS" && heading && (
                <h1 className="w-auto">
                  <span className={style.admin_heading}>{heading}</span> {subHeading && "|"}{" "}
                  <span className={style.admin_subheading}>{<CustomerDetails />}</span>
                </h1>
              )}
              {type !== "CUSTOMER_DETAILS" && heading && (
                <h1 className="w-auto">
                  <span className={style.admin_heading}>{heading}</span> {subHeading && "|"}{" "}
                  <span className={style.admin_subheading}>{subHeading}</span>
                </h1>
              )}

              {reportHeading && <div className={style.admin_subheading}>{reportHeading}</div>}
            </>
          )}
          {workListView && (
            <h2 className="w-auto">
              <span className={style.tab_hdg}>
                {userDetails && userDetails.firstName !== null ? userDetails.firstName + " " + userDetails.lastName : ""}
              </span>
              <span className={style.tab_content_subline}>
                <strong>Facility/Location: </strong>
                {facilityData ? getFacilityLabel(facilityData) : ""}
              </span>
            </h2>
          )}
        </div>

        {!formulary && (
          <div className="d-flex justify-content-end align-items-center col-lg-4 p-0">
            {!patientView && <PatientSearch />}
            <Notification />
            <button className={`d-inline ${style.userpic_blk}`}>
              <img
                className={`${style.p_link} ${style.user_picture}`}
                src={Details?.profilePicture ? Details?.profilePicture : UserProfile}
                onClick={() => setDrop((prev) => !prev)}
                ref={dropRef}
                alt="User profile"
              />
              {viewDrop && (
                <div className={`dropdown-menu dropdown-menu-right show p-0 m-0 ${style.medline_menu}`} ref={dropRef}>
                  <Link to="/userprofile">
                    <div className={`${style.link} ${style.list_menu}`}>User Profile</div>
                  </Link>
                </div>
              )}
            </button>
          </div>
        )}
      </nav>
    </div>
  );
};
